import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { financeQueryKeys } from '@/common/queryKeys/finance';
import { ItemFinancialsAggregateApi } from '@/features/financials/api/item-financials-aggregate';

export const useItemFinancialsAggregateQuery = (
  itemIds: number[],
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: financeQueryKeys.itemFinancialsAggregate.bulk(itemIds),
    queryFn: ({ signal }) =>
      ItemFinancialsAggregateApi.getItemFinancialsAggregate(
        [...itemIds].sort((a, b) => a - b),
        signal,
      ),
    enabled: (options.enabled ?? true) && itemIds.length > 0,
    placeholderData: keepPreviousData,
  });
};
